// extracted by mini-css-extract-plugin
export var leftAlign = "_2r-2";
export var popper = "_2r-0";
export var subtitle = "_2r-1";